import { useState, useEffect } from "react";

function useScreenSize() {
  const [screen, setScreen] = useState(() => {
    if (typeof window !== "undefined") {
      const width = window.innerWidth;
      return {
        isMobile: width <= 767,
        isTablet: width >= 768 && width <= 991,
        isDesktop: width >= 992,
      };
    }
    return {
      isMobile: false,
      isTablet: false,
      isDesktop: true, // default to desktop on SSR
    };
  });

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setScreen({
        isMobile: width <= 767,
        isTablet: width >= 768 && width <= 991,
        isDesktop: width >= 992,
      });
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return screen;
}

export default useScreenSize;
